import "./style.css";
import React, { useState, useEffect } from "react";
import loadConfig from "../../Services/apiService";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

export default function InputAHSF(props) {
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const [inputValue, setInputValue] = useState(
    props.value !== undefined && props.value !== ""
      ? props.value
      : props.defaultValue || ""
  );
  useEffect(() => {
    if (props.clear) {
      setInputValue(""); // clear the input value if clear prop is true
    }
  }, [props.clear]);

  // Synchronize the input value when the `value` prop changes
  useEffect(() => {
    if (props.value !== undefined && props.value !== "") {
      setInputValue(props.value);
    }
  }, [props.value]);

  const addCommas = (num) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // const addDot = (num) =>
  // num.toString().replace(/\B(?=() /gm, ".");
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

  const handleChange = (e) => {
    let fieldsName = props.fieldsName;
    let code = JsonDataa?.JsonData[props.fieldsName]?.[fieldsName];
    let wordsNumber = code ? code.wordsNumber : 100;

    const value = e.target.value;
    // console.log(e.target.value);
    const wordsArray = value;
    // .trim().split(/\s+/);
    if (props.comma == true) {
      e.target.value = removeNonNumeric(e.target.value);
      setInputValue(
        // addDot(
        addCommas(removeNonNumeric(e.target.value))
        // )
      );
      if (props.onChange) {
        props.onChange(e);
      }
    } else {
      if (wordsArray.length <= wordsNumber) {
        setInputValue(value);

        if (props.onChange) {
          props.onChange(e);
        }
      }
    }
    // props.onChange
  };
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return JsonDataa ? (
    <>
      {props.show && (
        <div className="containerInputAHSF">
          <div className="label-container">
         {!props.hidelable?
          <label
              className="labeInput"
              for={JsonDataa?.JsonData[props.fieldsName]?.code}
              title={JsonDataa?.JsonData[props.fieldsName]?.nameEN}
            >
              {JsonDataa?.JsonData[props.fieldsName]?.nameAR}
              {JsonDataa?.JsonData[props.fieldsName]?.isRequired ? (
               !props.showAsterisk? <span>*</span>:""
              ) : (
                ""
              )}
            </label>:""}
            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
                &nbsp;
              </span>
            )}
          </div>
          <input
            type={props.type}
            id={JsonDataa?.JsonData[props.fieldsName]?.code}
            value={inputValue} // Use the inputValue from state
            placeholder={JsonDataa?.JsonData[props.fieldsName]?.PlaceHolder}
            onChange={handleChange}
            disabled={props.disabled}
            required={props.required}
            className={props.showValidationMessage ? "input-error" : ""}
            onBlur={props.onBlur}
            onWheel={(e) => e.target.blur()}
          
          />
          {/* {props.showValidationMessage && (
            <p className="error-message">{props.validationMessage}</p>
          )} */}
        </div>
      )}
    </>
  ) : (
    ""
  );
}
